/**
 * cplace frontend software development kit API
 * cplace frontend software development kit API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Autocomplete hit alert.
 */
export interface AutocompleteHitAlert {
  /**
   * Tooltip explaining the alert.
   */
  tooltip: string;
  /**
   * Alert severity.
   */
  alertIconSeverity: AutocompleteHitAlert.AlertIconSeverityEnum;
}
export namespace AutocompleteHitAlert {
  export type AlertIconSeverityEnum = 'info' | 'success' | 'warning' | 'error';
  export const AlertIconSeverityEnum = {
    Info: 'info' as AlertIconSeverityEnum,
    Success: 'success' as AlertIconSeverityEnum,
    Warning: 'warning' as AlertIconSeverityEnum,
    Error: 'error' as AlertIconSeverityEnum,
  };
}
